module.exports = "pegasus/assets/tech/medium/6.jpg";